export default __webpack_public_path__ + "static/media/building.a5d3a6c0.svg";